import { render, staticRenderFns } from "./EventOverview.vue?vue&type=template&id=4fca5e7a&scoped=true"
import script from "./EventOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventOverview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventOverview.vue?vue&type=style&index=0&id=4fca5e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fca5e7a",
  null
  
)

export default component.exports